'use client';

import { c as _c } from "react/compiler-runtime";
import LinkComponent, { LinkComponentLink } from '../link/link.component';
import { ReactElement, memo } from 'react';
import { CmsComponentContext } from '@spa/components/container/CmsComponentContext';
import ConfigurableCmsValidity from '@spa/top-level-components/cms-page/metadata/configurable/configurable-cms-validity.component';
import ImageComponent from '@spa/components/image-component/image.component';
import classNames from 'clsx';
import styles from './headline.component.module.scss';
import { usePathname } from 'next/navigation';
export interface Props {
  readonly id: string;
  readonly headline: string;
  readonly subHeadline: string | null;
  readonly ariaLabelledby?: string;
  readonly link: LinkComponentLink | null;
  readonly headlineTag?: 'h1' | 'h2' | 'span';
  readonly usedInFullWidthComponent?: boolean;
  readonly editorMode?: boolean;
  readonly dateFrom?: number | null;
  readonly dateTo?: number | null;
  readonly context?: CmsComponentContext | null;
  readonly className?: string;
}
type HeadlineProps = {
  readonly as?: React.ElementType;
  readonly children: React.ReactNode;
  readonly className?: string;
  readonly id?: string;
};
const Headline: React.FC<HeadlineProps> = t0 => {
  const $ = _c(5);
  const {
    as: t1,
    className,
    children,
    id
  } = t0;
  const Tag = t1 === undefined ? "span" : t1;
  let t2;
  if ($[0] !== Tag || $[1] !== children || $[2] !== className || $[3] !== id) {
    t2 = <Tag className={className} id={id}>{children}</Tag>;
    $[0] = Tag;
    $[1] = children;
    $[2] = className;
    $[3] = id;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
function HeadlineComponent(t0) {
  const $ = _c(30);
  const {
    id,
    headline,
    link,
    subHeadline,
    headlineTag: t1,
    usedInFullWidthComponent: t2,
    editorMode: t3,
    dateTo: t4,
    dateFrom: t5,
    context: t6,
    ariaLabelledby,
    className
  } = t0;
  const headlineTag = t1 === undefined ? "span" : t1;
  const usedInFullWidthComponent = t2 === undefined ? false : t2;
  const editorMode = t3 === undefined ? false : t3;
  const dateTo = t4 === undefined ? null : t4;
  const dateFrom = t5 === undefined ? null : t5;
  const context = t6 === undefined ? null : t6;
  const pathname = usePathname();
  let t7;
  bb0: switch (context) {
    case CmsComponentContext.BANNER:
      {
        t7 = "h3 bold";
        break bb0;
      }
    case CmsComponentContext.FOOTER:
      {
        t7 = "h4 bold";
        break bb0;
      }
    default:
      {
        t7 = "h2";
      }
  }
  const textClass = t7;
  let t8;
  if ($[0] !== className || $[1] !== usedInFullWidthComponent) {
    t8 = classNames({
      [styles.headline]: true,
      [styles["headline--full-width"]]: usedInFullWidthComponent
    }, className);
    $[0] = className;
    $[1] = usedInFullWidthComponent;
    $[2] = t8;
  } else {
    t8 = $[2];
  }
  const headlineStyles = t8;
  let t9;
  if ($[3] !== headline) {
    t9 = headline.trim();
    $[3] = headline;
    $[4] = t9;
  } else {
    t9 = $[4];
  }
  const trimmedHeadline = t9;
  let t10;
  if ($[5] !== subHeadline) {
    t10 = subHeadline?.trim();
    $[5] = subHeadline;
    $[6] = t10;
  } else {
    t10 = $[6];
  }
  const trimmedSubHeadline = t10;
  let t11;
  if ($[7] !== context || $[8] !== dateFrom || $[9] !== dateTo || $[10] !== editorMode || $[11] !== headlineStyles || $[12] !== headlineTag || $[13] !== link || $[14] !== pathname || $[15] !== textClass || $[16] !== trimmedHeadline || $[17] !== trimmedSubHeadline) {
    t11 = id_0 => <div className={headlineStyles} {...pathname?.includes("no-results") && {
      "data-track-id": "zeroResultsContainer"
    }}>{editorMode && <ConfigurableCmsValidity dateFrom={dateFrom} dateTo={dateTo} />}<div className={headlineTag !== "h1" ? styles.headline__headline : undefined}><Headline as={headlineTag} className={classNames({
          [textClass]: headlineTag !== "h2",
          [styles["headline__headline-tag"]]: true
        })} id={id_0}>{trimmedHeadline}</Headline>{link && <ImageComponent src="/assets/icons/arrow_forward_orange.svg" height={16} width={16} alt="forward" className={styles.headline__icon} />}</div>{trimmedSubHeadline && <span className={classNames(styles["headline__sub-headline"], {
        [styles["headline__sub-headline--footer"]]: context === CmsComponentContext.FOOTER
      })}>{trimmedSubHeadline}</span>}</div>;
    $[7] = context;
    $[8] = dateFrom;
    $[9] = dateTo;
    $[10] = editorMode;
    $[11] = headlineStyles;
    $[12] = headlineTag;
    $[13] = link;
    $[14] = pathname;
    $[15] = textClass;
    $[16] = trimmedHeadline;
    $[17] = trimmedSubHeadline;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  const headlineContent = t11;
  let headlineComponent;
  if (!trimmedHeadline && !trimmedSubHeadline) {
    let t12;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
      t12 = <></>;
      $[19] = t12;
    } else {
      t12 = $[19];
    }
    headlineComponent = t12;
  } else {
    if (link) {
      let t12;
      if ($[20] !== headlineContent || $[21] !== id) {
        t12 = headlineContent(id);
        $[20] = headlineContent;
        $[21] = id;
        $[22] = t12;
      } else {
        t12 = $[22];
      }
      let t13;
      if ($[23] !== id || $[24] !== link || $[25] !== t12) {
        t13 = <LinkComponent link={link} ariaLabelledBy={id}>{t12}</LinkComponent>;
        $[23] = id;
        $[24] = link;
        $[25] = t12;
        $[26] = t13;
      } else {
        t13 = $[26];
      }
      headlineComponent = t13;
    } else {
      let t12;
      if ($[27] !== ariaLabelledby || $[28] !== headlineContent) {
        t12 = headlineContent(ariaLabelledby);
        $[27] = ariaLabelledby;
        $[28] = headlineContent;
        $[29] = t12;
      } else {
        t12 = $[29];
      }
      headlineComponent = t12;
    }
  }
  return headlineComponent;
}
export default memo(HeadlineComponent);